import { Button, Input } from "antd";
import React, { CSSProperties } from 'react';

export interface IProps {
  inputCss?: CSSProperties
  onChange: (searchValue: string) => void;
}

interface IState {
  currentValue: string;
}

class SimpleColumnSearch extends React.Component<IProps, IState>
{
  constructor(props: IProps) {
    super(props);
    this.state = {
      currentValue: '',
    };
  }

  public render() {
    return <div className={'simple-column-search'}>
      <Input value={this.state.currentValue} onChange={this.handleInputChange} style={this.props.inputCss} />
      <Button onClick={this.handleGo} type={'primary'}>Go</Button>
      <Button onClick={this.handleReset}>Reset</Button>
    </div>;
  }

  private handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      currentValue: e.target.value,
    });
  };
  private handleGo = () => this.props.onChange(this.state.currentValue);
  private handleReset = () => {
    this.setState({
      currentValue: '',
    });
    this.props.onChange('');
  };
}

export default SimpleColumnSearch;
